export enum DossierProcessingStatus {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_UNRECOGNIZED_DOCUMENTS = 'COMPLETED_WITH_UNRECOGNIZED_DOCUMENTS'
}
